import { render, staticRenderFns } from "./ThePersonDetails.vue?vue&type=template&id=088586c4&"
import script from "./ThePersonDetails.vue?vue&type=script&lang=js&"
export * from "./ThePersonDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports